import { useState } from "react";
import { Box } from "@mui/system";
import { HeaderLine } from "component/organisms/header-line";
import { PageContainer } from "component/templates/page-container";
import { useZohoAuthContext, ZohoAuthProvider } from "context/ZohoAuthContext";
import { Calender } from "component/organisms/calender";

function Route() {
  const { initialData } = useZohoAuthContext();
  //
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedConfigs, setSelectedConfigs] = useState([]);
  const [selectedView, setSelectedView] = useState(null);

  if (initialData?.EntityId?.length > 50) {
    return (
      <Box
        sx={{
          height: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        At most 50 record can be selected
      </Box>
    );
  }

  return (
    <PageContainer
      borderTop
      pageHeader={
        <HeaderLine
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
          //
          selectedConfigs={selectedConfigs}
          setSelectedConfigs={setSelectedConfigs}
          //
          selectedView={selectedView}
          setSelectedView={setSelectedView}
        />
      }
    >
      <Calender resources={selectedUsers} selectedSettings={selectedConfigs} selectedView={selectedView} />
    </PageContainer>
  );
}

export function ButtonRoute() {
  return (
    <ZohoAuthProvider height="80%" width="80%">
      <Route />
    </ZohoAuthProvider>
  );
}
